import { Select, type RefSelectProps } from 'antd'
import clsx from 'clsx'
import { forwardRef, type Ref } from 'react'

import type { SingleOrMultipleSelectProps } from '@/components/types'
import { STATUSES } from '@/constants/common/message.constants'
import {
  TAX_CALCULATION_TYPE,
  TAX_CALCULATION_TYPE_LABEL,
  type TaxCalculationType
} from '@/libs/api/types'
import { useSelectOnChangeHandler } from '@/libs/hooks'

type Props = SingleOrMultipleSelectProps<
  TaxCalculationType,
  TaxCalculationTypeOption
>

type TaxCalculationTypeOption = { label: string; value: TaxCalculationType }

const options: TaxCalculationTypeOption[] = Object.values(
  TAX_CALCULATION_TYPE
).map((type) => ({
  label: TAX_CALCULATION_TYPE_LABEL[type],
  value: type
}))

/**
 * 税計算方法を選択するSelect
 */
export const TaxCalculationTypeSelect = forwardRef(
  (
    {
      className,
      placeholder = STATUSES.UNSELECTED,
      value,
      mode,
      onChange,
      ...props
    }: Props,
    ref: Ref<RefSelectProps> | undefined
  ) => {
    const handleChange = useSelectOnChangeHandler({ mode, onChange })
    return (
      <Select
        ref={ref}
        {...props}
        mode={mode}
        value={value}
        onChange={handleChange}
        className={clsx(['min-w-[140px]', className])}
        options={options}
        placeholder={placeholder}
      />
    )
  }
)
